import { isEmpty } from 'lodash'

const departmentNames = (task) => {
  return !isEmpty(task?.departments)
    ? task.departments.map((department) => department?.name).join('; ')
    : 'Não há vínculos com o departamento'
}
export default departmentNames
